import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/copy';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-abyss py-12 sm:py-24" id="faq" data-id="element-26" data-mp="1l9o8reb6y9od">
      <div className="mx-auto max-w-3xl px-4 sm:px-8" data-id="element-27" data-mp="1ge0fontl8wdl">
        <h2 className="text-center font-display text-2xl uppercase leading-[0.95] text-bone sm:text-4xl" data-id="element-28" data-mp="2e067k34vtovz">
          Preguntas Frecuentes
        </h2>

        <div className="mt-8 space-y-3 sm:mt-12 sm:space-y-4" data-id="element-29" data-mp="291wcdsj5qoad">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className="border border-bone/10 bg-steel" data-id="element-30" data-mp="1z3yo551asrhr" data-mpi={i}>
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="flex w-full items-center justify-between px-4 py-4 text-left sm:px-6 sm:py-5" data-id="element-31" data-mp="sn3eo63bzjh4">
                  <span className="font-cond text-lg uppercase tracking-wide text-bone sm:text-xl" data-id="element-32" data-mp="phej02741bfc">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-chartreuse transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-33" data-mp="ug9adsj588b2" />
                </button>
                <AnimatePresence data-id="element-34" data-mp="6qwwifcvfc2f">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden" data-id="element-35" data-mp="6plsqfjfe4bb">
                      <div className="border-t border-bone/10 px-4 pb-5 pt-3 font-body text-[0.95rem] leading-relaxed text-bone/80 sm:px-6 sm:pb-6 sm:text-base" data-id="element-36" data-mp="1q93xp8zun63">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}